module.exports = __webpack_public_path__ + "img/3.875270b0.jpg";